import { $api } from "../AxiosInstance";

export class PaymentService {
  /**
   * Get all payment systems
   */
  static async paymentSystemsGetAll() {
    return await $api.get("/api/admin/paymentSystem/all");
  }

  /**
   * Get payment system by ID
   * @param {Number} id
   */
  static async paymentSystemsGet(id) {
    return await $api.get("/api/admin/paymentSystem", { params: { id } });
  }

  /**
   * Save payment system
   * @param {Object} params
   */
  static async paymentSystemsSave(params) {
    return await $api.post("/api/admin/paymentSystem", params);
  }

  /**
   * Create payment system
   * @param {Object} params
   */
  static async paymentSystemsCreate(params) {
    return await $api.put("/api/admin/paymentSystem", params);
  }

  /**
   * Delete payment system
   * @param {Number} id
   */
  static async paymentSystemsDelete(id) {
    return await $api.delete("/api/admin/paymentSystem", { params: { id } });
  }

  /**
   * Change payment systems order
   * @param {Array<Number>} paymentSystemSortedIds
   */
  static async changePaymentSystemsOrder(paymentSystemSortedIds) {
    return await $api.post("/api/admin/paymentSystem/changeIndices", {
      paymentSystemSortedIds,
    });
  }

  /**
   * Create minimal price for payment system
   * @param {Number} paymentSystemId
   * @param {Number} currencyId
   * @param {Number} minPrice
   */
  static async createMinimalPriceForPaymentSystem(
    paymentSystemId,
    currencyId,
    minPrice
  ) {
    return await $api.put("/api/admin/minimalPriceForPaymentSystem", {
      paymentSystemId,
      currencyId,
      minPrice,
    });
  }

  /**
   * Save minimal price for payment system
   * @param {Number} id
   * @param {Number} paymentSystemId
   * @param {Number} currencyId
   * @param {Number} minPrice
   */
  static async saveMinimalPriceForPaymentSystem(
    id,
    paymentSystemId,
    currencyId,
    minPrice
  ) {
    return await $api.post("/api/admin/minimalPriceForPaymentSystem", {
      id,
      paymentSystemId,
      currencyId,
      minPrice,
    });
  }

  /**
   * Delete minimal price for payment system
   * @param {Number} id
   */
  static async deleteMinimalPriceForPaymentSystem(id) {
    return await $api.delete("/api/admin/minimalPriceForPaymentSystem", {
      params: { id },
    });
  }

  /**
   * Get block payment history
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   */
  static async getBlockPaymentHistory(params) {
    return await $api.post("/api/admin/blockPaymentHistory", {
      ...params,
      page: params.page - 1,
    });
  }

  /**
   * Get count of block payment history
   */
  static async getCountBlockPaymentHistory() {
    return await $api.get("/api/admin/blockPaymentHistory/count");
  }
}
